import { APP_INITIALIZER, EnvironmentProviders, Provider, importProvidersFrom, inject } from '@angular/core';
import { TRANSLOCO_CONFIG, TRANSLOCO_LOADER, TranslocoModule, TranslocoService, translocoConfig } from '@ngneat/transloco';

import { TranslocoHttpLoader } from 'app/core/transloco/transloco.http-loader';
import { lastValueFrom } from 'rxjs';

// Clé pour stocker la langue dans le localStorage
const LANGUAGE_LOCAL_STORAGE_KEY = 'selectedLanguage';

export const provideTransloco = (): Array<Provider | EnvironmentProviders> =>
{
    return [
        importProvidersFrom(TranslocoModule),
        {
            // Provide the default Transloco configuration
            provide : TRANSLOCO_CONFIG,
            useValue: translocoConfig({
                availableLangs      : [
                    {
                        id: 'en',
                        label: 'English',
                    },
                    {
                        id: 'fr',
                        label: 'French',
                    },
                    {
                        id: 'it',
                        label: 'Italian',
                    },
                    {
                        id: 'es',
                        label: 'Spanish',
                    },
                    {
                        id: 'de',
                        label: 'German',
                    },
                ],
                defaultLang         : 'fr',
                fallbackLang        : 'en',
                reRenderOnLangChange: true,
                prodMode            : true, // Set to false for development mode
            }),
        },
        {
            // Provide the default Transloco loader
            provide : TRANSLOCO_LOADER,
            useClass: TranslocoHttpLoader,
        },
        {
            // Preload the default language before the app starts to prevent empty/jumping content
            provide   : APP_INITIALIZER,
            useFactory: () =>
                {
                    const translocoService = inject(TranslocoService);
                    
                    return () => {
                        // Récupérer la langue sauvegardée du localStorage ou utiliser la langue par défaut
                        const savedLang = localStorage.getItem(LANGUAGE_LOCAL_STORAGE_KEY);
                        const defaultLang = translocoService.getDefaultLang();
                        
                        // Vérifier si la langue sauvegardée existe et est disponible
                        const langToUse = savedLang && translocoService.isLang(savedLang) 
                            ? savedLang 
                            : defaultLang;
                        
                        // Définir la langue active
                        translocoService.setActiveLang(langToUse);
                        
                        // S'abonner aux changements de langue pour les sauvegarder
                        translocoService.langChanges$.subscribe(lang => {
                            localStorage.setItem(LANGUAGE_LOCAL_STORAGE_KEY, lang);
                        });
                        
                        // Charger la langue
                        return lastValueFrom(translocoService.load(langToUse));
                    };
                },
                multi     : true,
        },
    ];
};
